package com.sddamico.swigmore.ds

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover

/** Apply raw CSS declarations. The design is authored as inline CSS, so components speak it directly. */
fun Modifier.css(vararg declarations: Pair<String, String>) = styleModifier {
  declarations.forEach { (name, value) -> property(name, value) }
}

@InitSilk
fun initSwBase(ctx: InitSilkContext) {
  ctx.stylesheet.registerStyleBase("body") {
    Modifier.css(
      "margin" to "0",
      "font-family" to SwType.body,
      "-webkit-font-smoothing" to "antialiased",
    )
  }
  ctx.stylesheet.registerStyleBase("a") { Modifier.css("color" to SwColor.gold) }
  ctx.stylesheet.registerStyleBase("a:hover") { Modifier.css("color" to SwColor.cream) }
}

/**
 * Shared interaction feedback for pressable controls: hover brightens, press nudges down, keyboard
 * focus shows a gold ring. Touches only `filter` / `transform` / `outline`-free box-shadow, so a
 * control's own background and stitch outline are left intact.
 */
val PressableStyle = CssStyle {
  base { Modifier.css("transition" to "transform 120ms ease-out, filter 120ms ease-out, background .12s") }
  hover { Modifier.css("filter" to "brightness(1.06)") }
  active { Modifier.css("transform" to "translateY(1px)") }
  focusVisible { Modifier.css("box-shadow" to "0 0 0 2px ${SwColor.gold}") }
}

/** Hover tint for list rows on the field (the "The Field" team list). */
val FieldRowStyle = CssStyle {
  base { Modifier.css("background" to "rgba(239,229,201,.05)", "transition" to "background .12s") }
  hover { Modifier.css("background" to SwColor.tintOnFieldHover) }
}
